export default __webpack_public_path__ + "static/media/ico-generic-db-score-elevated.c1826ecf.svg";